"use strict";

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

require("core-js/modules/es6.array.from.js");

require("core-js/modules/es6.array.slice.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name.js");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("../../../sass/components/shared/CharacterProfileImage.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var firstCapsLetter = function firstCapsLetter(str) {
  var _str$charAt;

  return (str === null || str === void 0 ? void 0 : (_str$charAt = str.charAt) === null || _str$charAt === void 0 ? void 0 : _str$charAt.call(str, 0).toUpperCase()) || '';
};

var CharacterProfileImage = function CharacterProfileImage(_ref) {
  var image = _ref.image,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? '' : _ref$name,
      _ref$customClasses = _ref.customClasses,
      customClasses = _ref$customClasses === void 0 ? [] : _ref$customClasses,
      _ref$customProfileImg = _ref.customProfileImgClasses,
      customProfileImgClasses = _ref$customProfileImg === void 0 ? [] : _ref$customProfileImg,
      _ref$customClassNoImg = _ref.customClassNoImg,
      customClassNoImg = _ref$customClassNoImg === void 0 ? [] : _ref$customClassNoImg,
      _ref$customClassFont = _ref.customClassFont,
      customClassFont = _ref$customClassFont === void 0 ? [] : _ref$customClassFont;
  var initials = typeof name === 'string' ? firstCapsLetter(name) : "".concat(firstCapsLetter(name === null || name === void 0 ? void 0 : name.first)).concat(firstCapsLetter(name === null || name === void 0 ? void 0 : name.last));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _classnames.default.apply(void 0, ['char-profile-img-wrapper'].concat(_toConsumableArray(customClasses)))
  }, image ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      backgroundImage: "url('".concat(image, "')")
    },
    className: _classnames.default.apply(void 0, ['profile-img'].concat(_toConsumableArray(customProfileImgClasses)))
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: _classnames.default.apply(void 0, ['profile-img', 'char-profile-img'].concat(_toConsumableArray(customClassNoImg)))
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _classnames.default.apply(void 0, ['char-style'].concat(_toConsumableArray(customClassFont)))
  }, initials)));
};

var _default = CharacterProfileImage;
exports.default = _default;